import React from 'react'
import PropTypes from 'prop-types'
import { shouldShowCheckBox } from '../customColumns'

const TableHeader = ({
  orderBy,
  orderAsc,
  headerGroups,
  isSelectable,
  onClick,
  validateSelectable,
}) => {
  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) =>
            shouldShowCheckBox(column, isSelectable, validateSelectable) ? (
              <th
                {...column.getHeaderProps()}
                style={{
                  width: column.id === 'selection' ? '2%' : '5%',
                  background: '#F0F0F0',
                  color: '#3F3D3C',
                  height: '36px',
                  boxShadow:
                    'inset -1px 0px 0px #D7D7D7, inset 0px -1px 0px #D7D7D7',
                  textAlign: 'left',
                  fontWeight: 'bold',
                  position: 'sticky',
                  zIndex: 0,
                  top: 0,
                  paddingLeft: 5,
                  paddingRight: 5,
                }}
                onClick={() => {
                  if (
                    column.id === 'sRut' ||
                    column.id === 'sRUT' ||
                    column.id === 'sEmpleado'
                  ) {
                    onClick?.('RUT')
                  } else if (column.id === 'sNombre') {
                    onClick?.('NOMBRE')
                  } else if (column.id === 'dFechaCreacion') {
                    onClick?.('DATE')
                  } else if (column.id === 'sSoloNombre') {
                    onClick?.('SOLONOMBRE')
                  } else if (column.id === 'sApellidos') {
                    onClick?.('APELLIDOS')
                  }
                }}
              >
                <div style={{ position: 'relative' }}>
                  <div
                    style={{
                      ...(column.columnStyle ? column.columnStyle : {}),
                      ...(column.toEnd
                        ? {
                            display: 'flex',
                            alighItems: 'center',
                            justifyContent: 'flex-end',
                          }
                        : {}),
                    }}
                  >
                    {column.render('Header', {
                      label: column.label,
                      isSort: orderAsc,
                      sortBy: orderBy,
                      validateSelectable,
                      column,
                    })}
                  </div>
                </div>
              </th>
            ) : null,
          )}
        </tr>
      ))}
    </thead>
  )
}

TableHeader.propTypes = {
  headerGroups: PropTypes.array,
  isSelectable: PropTypes.bool,
  onClick: PropTypes.func,
  orderAsc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  orderBy: PropTypes.string,
  validateSelectable: PropTypes.func,
  withSort: PropTypes.bool,
}

export default TableHeader
